module.exports = __webpack_public_path__ + "img/symbol_9.8d435577.png";